export default __webpack_public_path__ + "static/bg-boxes--mobile-0da1b9c9b6055934acb13c59fcba4fc5.jpg";